// extracted by mini-css-extract-plugin
export default {"input":"I8-z","button":"J8-z","selected":"K8-z","unavailable":"L8-z","oos":"M8-z","image":"N8-z","paperCutDisabledOverlay":"O8-z"};